module.exports = __webpack_public_path__ + "static/media/g-2-d.48a4d216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-2-d.jpg
// module id = 1131
// module chunks = 33